/**
 * 订阅折扣弹窗（第 277 批）：60s 计时弹出 / 频控 / 左下角入口 / 一键复制折扣码 / 焦点管理。
 *
 * 订阅走的仍是弹窗里那个原生 Shopify customer 表单、同一个 /contact 端点、同一份表单数据
 *（本脚本不构造、不伪造任何提交内容）。区别只是把提交从「整页 POST 回流」换成 fetch：
 * 原生 POST 会刷新整页，刷新期间弹窗是关着的，用户看到的是「点按钮 → 页面闪一下 →
 * 一两秒后弹窗才出来」；改成 fetch 后页面不刷新，服务端渲染的成功态/错误态片段直接换进弹窗。
 * 片段不可判定时（例如被 Shopify 的机器人校验拦住）退回原生提交，行为与改动前一致。
 *
 * 频控：
 *   · localStorage  monsgaPromoSubscribed=1 → 已订阅成功，之后不再自动弹出、不再显示左下角入口
 *   · sessionStorage monsgaPromoDismissed=1  → 本次会话已关闭过，不再自动强弹（入口保留）
 *   · sessionStorage monsgaPromoBadgeOff=1   → 客户自己关掉了左下角入口，本次浏览不再出现
 *     （关掉标签页/下次打开网站即失效）
 *
 * 左下角入口本身常驻：页面加载即显示，不必先等弹窗被关掉（第 294 批）。
 *
 * 与站内其它弹窗的互斥（第 489 批）：任何一个 <dialog> 正开着（比如产品页的「离开意向」弹窗）
 * 都不自动弹，等它关掉再弹（最多重试 6 次 ≈ 90 秒）；本弹窗关闭时在 <html> 上写
 * data-monsga-modal-closed 时间戳，供 monsga-exit-offer.js 读取（那边 30 秒安静期）。
 */
(() => {
  const root = document.querySelector('[data-monsga-promo]');
  if (!root) return;

  const dialog = root.querySelector('[data-monsga-promo-dialog]');
  const launcher = root.querySelector('[data-monsga-promo-launcher]');
  const pill = root.querySelector('[data-monsga-promo-open]');
  const shut = root.querySelector('[data-monsga-promo-shut]');
  const form = root.querySelector('.monsga-promo__form');
  const success = root.querySelector('[data-monsga-promo-success]');
  const errorBox = root.querySelector('[data-monsga-promo-error]');
  if (!dialog || !launcher || !pill) return;

  const KEY_SUBSCRIBED = 'monsgaPromoSubscribed';
  const KEY_DISMISSED = 'monsgaPromoDismissed';
  const KEY_BADGE_OFF = 'monsgaPromoBadgeOff';
  const KEY_SCROLL = 'monsgaPromoScroll';

  const read = (store, key) => {
    try {
      return store.getItem(key);
    } catch (error) {
      return null;
    }
  };
  const write = (store, key, value) => {
    try {
      store.setItem(key, value);
    } catch (error) {
      /* 隐私模式下 storage 不可用：退化成「本页内正常用，只是不记频控」 */
    }
  };

  // 原生 POST 会整页回流一次，先把滚动位置存下来，回来后复原，避免用户丢失阅读位置。
  const scrollY = read(sessionStorage, KEY_SCROLL);
  if (scrollY !== null) {
    sessionStorage.removeItem(KEY_SCROLL);
    window.scrollTo(0, Number(scrollY) || 0);
  }

  let subscribed = read(localStorage, KEY_SUBSCRIBED) === '1';
  const dismissed = read(sessionStorage, KEY_DISMISSED) === '1';
  // 入口的关闭键按会话记：客户自己关掉后本次浏览不再出现，下次打开网站照常回来（第 294 批）
  let badgeOff = read(sessionStorage, KEY_BADGE_OFF) === '1';

  const open = () => {
    if (dialog.open) return;
    launcher.hidden = true;
    dialog.showModal();
    // 默认态不把光标塞进邮箱框（一打开就顶着一圈紫色聚焦圈很吵）：焦点只留在弹窗内，
    // 键盘用户 Tab 一步即到输入框；错误态仍由 Liquid 渲染的 autofocus 抢焦点。
    const auto = dialog.querySelector('[autofocus]');
    if (auto) {
      auto.focus();
    } else {
      dialog.focus({ preventScroll: true });
    }
    // <dialog> 里的懒加载图偶尔不触发（弹窗开得太早时），打开时明确要一次
    const media = dialog.querySelector('.monsga-promo__media img');
    if (media && media.getAttribute('loading') === 'lazy') media.setAttribute('loading', 'eager');
  };

  const close = () => {
    if (dialog.open) dialog.close();
  };

  const showLauncher = () => {
    if (!subscribed && !badgeOff) launcher.hidden = false;
  };

  // 站内别的弹窗（产品页的「离开意向」弹窗等）正开着时不抢镜：等它关掉再弹，
  // 最多重试 6 次（≈90 秒）。互斥的另一半在 monsga-exit-offer.js（它读下面那个共享标记）。
  const otherDialogOpen = () => !!document.querySelector('dialog[open]:not([data-monsga-promo-dialog])');
  const openWhenFree = (attempt = 0) => {
    if (otherDialogOpen()) {
      if (attempt < 6) window.setTimeout(() => openWhenFree(attempt + 1), 15000);
      return;
    }
    open();
  };

  // 服务端已按 Liquid 渲染出成功态（form.posted_successfully?）⇒ 这次订阅真的成功了。
  if (success || errorBox) {
    if (success) {
      subscribed = true;
      write(localStorage, KEY_SUBSCRIBED, '1');
    }
    open();
  } else if (!subscribed) {
    // 左下角入口是常驻的：页面一加载就出来，不必先等弹窗被关掉（第 294 批）
    showLauncher();
    if (!dismissed) {
      const delay = Number(root.dataset.delay) || 60000;
      window.setTimeout(() => {
        if (document.hidden) {
          document.addEventListener('visibilitychange', () => { if (!document.hidden) openWhenFree(); }, { once: true });
        } else {
          openWhenFree();
        }
      }, delay);
    }
  }

  pill.addEventListener('click', open);

  if (shut) {
    shut.addEventListener('click', () => {
      launcher.hidden = true;
      badgeOff = true; // 本次浏览不再出现，下次打开网站照常回来
      write(sessionStorage, KEY_BADGE_OFF, '1');
    });
  }

  dialog.querySelectorAll('[data-monsga-promo-close]').forEach((button) => button.addEventListener('click', close));

  // 点弹窗外的遮罩区域也关闭
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) close();
  });

  // Esc / 关闭按钮 / 点遮罩都走这里：记为本次会话已关闭，并放出左下角入口
  dialog.addEventListener('close', () => {
    write(sessionStorage, KEY_DISMISSED, '1');
    // 共享标记：让「离开意向」弹窗知道刚有弹窗关过，别立刻又弹一个（见 monsga-exit-offer.js）
    document.documentElement.setAttribute('data-monsga-modal-closed', String(Date.now()));
    showLauncher();
  });

  const setSending = (sending) => {
    const button = form && form.querySelector('[data-monsga-promo-submit]');
    if (!button) return;
    if (sending) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (button.dataset.sending) button.textContent = button.dataset.sending;
    } else {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = button.dataset.label || button.textContent;
    }
  };

  // 退回原生提交：先记住滚动位置，回来后再复原
  const submitNatively = () => {
    if (!form) return;
    write(sessionStorage, KEY_SCROLL, String(window.scrollY));
    form.submit(); // 不走 submit 事件，不会二次进入本处理器
  };

  if (form) {
    // 用 fetch 把同一份表单数据 POST 到同一个 /contact，页面不刷新
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      setSending(true);
      // 兜底：真卡住时 12 秒后仍走原生提交，别让按钮永远停在「Subscribing…」
      const guard = window.setTimeout(submitNatively, 12000);
      let html = '';
      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          redirect: 'follow',
        });
        html = await response.text();
      } catch (error) {
        html = '';
      }
      const parsed = html ? new DOMParser().parseFromString(html, 'text/html') : null;
      const fresh = parsed && parsed.querySelector('#monsga-promo-form');
      const succeeded = !!(parsed && parsed.querySelector('[data-monsga-promo-success]'));
      const failed = !!(parsed && parsed.querySelector('[data-monsga-promo-error]'));
      // 服务端没给出可判定的片段（被校验拦下 / 结构变了）⇒ 退回原生提交，行为与改动前一致
      if (!fresh || (!succeeded && !failed)) {
        submitNatively();
        return;
      }
      window.clearTimeout(guard);
      form.innerHTML = fresh.innerHTML;
      if (succeeded) {
        subscribed = true;
        write(localStorage, KEY_SUBSCRIBED, '1');
      } else {
        const input = form.querySelector('.monsga-promo__input');
        if (input) input.focus();
      }
    });

    // 复制折扣码 / 继续购物：用事件委托，AJAX 换进来的新按钮也自动生效
    form.addEventListener('click', async (event) => {
      const copy = event.target.closest('[data-monsga-promo-copy]');
      const currentCode = form.querySelector('[data-monsga-promo-code]');
      if (copy && currentCode) {
        const value = currentCode.textContent.trim();
        if (!value) return;
        try {
          await navigator.clipboard.writeText(value);
        } catch (error) {
          // 退路：把码选中，用户可手动复制
          const range = document.createRange();
          range.selectNodeContents(currentCode);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          return;
        }
        copy.textContent = copy.dataset.copiedLabel || copy.textContent;
        copy.setAttribute('data-copied', 'true');
        window.setTimeout(() => {
          copy.textContent = copy.dataset.label || copy.textContent;
          copy.removeAttribute('data-copied');
        }, 2000);
        return;
      }
      if (event.target.closest('[data-monsga-promo-continue]')) close();
    });
  }
})();
